const en_master_finance = {
    "": "Finance",

    coa: "COA Settings",
    number: "Financial Numbering Settings",

    field_coa: {
        KAS: "cash",
        SALES: "sales",
        PPN_SALES: "sales PPN",
        HPP_SALES: "cost of goods sold",
        PURCHASE: "purchases",
        PPN_PURCHASE: "purchase PPN",
        CREDIT: "accounts payable",
        DEBIT: "accounts receivable",
        DP: "down payment",
        SUPPLY: "inventory",
        PRODUCTION: "production process",
        RETUR_CUSTOMER: "customer returns",
        STOCK_RETUR_CUSTOMER: "customer return inventory",
        RETUR_DEBT: "return payable settlement",
        COMMISSION: "commission",
        COMMISION_DEBT: "commission payable"
    },

    field_fn: {
        SALES: "sales",
        PURCHASE: "purchases",
        SALES_CODE: "sales code",
        PURCHASE_CODE: "purchases code",
    },

    error: {
        update_coa: "Failed to update COA settings",
        update_number: "Failed to update financial numbering settings",
    },

    success: {
        update_coa: "COA settings updated successfully",
        update_number: "Financial numbering settings updated successfully",
    }
}

export default en_master_finance;